<p-button [type]="type" [icon]="icon" [label]="label|translate" [disabled]="disabled"></p-button>